export default {
  MaintenanceMessage__FOOTER: "Southwest Airlines",
  MaintenanceMessage__TEXT1:
    "However, portions of the Southwest Airlines website are experiencing technical difficulties and are currently unavailable. We are working to make it available again as quickly as possible.",
  MaintenanceMessage__TEXT2:
    "We apologize for any inconvenience this may cause. Please try again later.",
  MaintenanceMessage__TITLE: "We want to get you where you need to go.",
};
